import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_JAP_HEADER_REQUEST = new HttpContextToken<boolean>(() => false);
export const SKIP_JAP_HEADER_CONTEXT = { context: new HttpContext().set(SKIP_JAP_HEADER_REQUEST, true) };

export const BPS_EINSTELLUNGEN_ENDPOINT = '/bps/einstellungen-b2e/rest/einstellungen';
export const BPS_PROFIL_ENDPOINT = '/bps/profil/rest';
// For onprem requests to the rwc-server, the endpoint must *not* start with a leading slash (/)
export const DEFAULT_LOGGING_ENDPOINT = 'jap/logging/v1';
export const JAP_PROPERTIES_ENDPOINT = 'rest/jap/properties';
// CIP, TODO: one should use the given authority in cip-config and/or topology.
export const CIP_OPENID_ENDPOINT = '/realms/cip';
export const CIP_ADMIN_ENDPOINT = '/admin/realms/cip';
export const AUTHORITIES_URLS = [
    // Azure Entra
    'https://login.microsoftonline.com',

    // Nevis
    'https://b2bidp',
    'https://b2cidp',

    CIP_OPENID_ENDPOINT
];
/**
 * @deprecated use JAP_PROPERTIES_ENDPOINT instead
 */
export const DEFAULT_CONFIGURATION_ENDPOINT = JAP_PROPERTIES_ENDPOINT;
